(() => {
  if (customElements.get('ns-classic-pack-upgrade')) return;

  customElements.define('ns-classic-pack-upgrade', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('[data-ns-pack-upgrade]');
      const picker = this.closest('variant-selects');
      const option = picker?.querySelector(`input[data-option-value-id="${this.dataset.optionId}"]`);
      if (!button || !option || option.disabled || option.classList.contains('disabled')) return;
      button.disabled = false;
      button.addEventListener('click', () => {
        if (option.checked) return;
        button.disabled = true;
        option.checked = true;
        option.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();
